<template>
  <v-container fluid>
    <div v-for="(items, category) in templateItems" :key="category" class="mb-3">
      <v-row
          class="background-color-white mr-sm-0"
          justify="space-between"
          :id="slug(category)"
      >
        <v-col class="pl-10">
          <h5 class="font-size-lg font-weight-medium">{{ category }}</h5>
        </v-col>
      </v-row>
      <v-row class="background-color-white mr-sm-0 px-6">
        <v-col
            v-for="item in templateItems[category]"
            :key="item.upc"
            class="position-relative mb-5"
            cols="6"
            md="4"
            xl="3"
        >
          <Product :product="item" :size="'md'" />
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>
<script>
import {mapGetters} from 'vuex';
import {slug} from 'github-slugger';
import Product from "@/components/Product/index.vue";

export default {
  name: "TemplateView",
  components: {Product},
  computed: {
    ...mapGetters("template", { templateItems: "byCategory" }),
  },
  methods: { slug },
}
</script>
